import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
const LinearProgressWithLabel = (props)=>{
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            width: '100%',
            mr: 1
        }
    }, /*#__PURE__*/ React.createElement(LinearProgress, {
        variant: "determinate",
        ...props
    })), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            minWidth: 35
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            color: 'text.secondary'
        }
    }, `${Math.round(props.value)}%`)));
};
LinearProgressWithLabel.propTypes = {
    value: PropTypes.number
};
export default LinearProgressWithLabel;
